import axios from "axios";
import { REST_API_BASE_URL_REMOTE } from './PathEnvironment';

const TOKEN_KEY = "token";

const axiosInstance = axios.create({
  baseURL: REST_API_BASE_URL_REMOTE,
  timeout: 30000,
});

const readToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};

// Interceptor to add the auth token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    let token = readToken();
    if (token) {
      let cleanToken = token.trim();
      while (cleanToken.startsWith("Bearer ")) {
        cleanToken = cleanToken.substring(7).trim();
      }
      if (cleanToken) {
        config.headers['Authorization'] = `Bearer ${cleanToken}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Interceptor to handle responses and detailed backend errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data, config } = error.response;
      const errorMessage = data?.message || data?.error || error.message;
      console.error(`[API Error ${status}]:`, errorMessage, data);

      // A 401 only means "session expired" when we actually sent a token
      // (a wrong password on the login form must not trigger a logout).
      const sentToken = Boolean(config?.headers?.Authorization);
      const isAuthCall = String(config?.url || '').includes('api/auth/login');
      if (status === 401 && sentToken && !isAuthCall) {
        // Lazy import avoids a circular dependency with AuthService.
        import('./AuthService').then(({ logout }) => logout());
      }
    }
    return Promise.reject(error);
  }
);

/** Human readable message for an axios error (backend message when available). */
export const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (!error.response) return null; // network error: let the caller show a translated message
  const data = error.response.data;
  if (typeof data === 'string' && data.trim()) return data;
  return data?.message || fallback;
};

export default axiosInstance;
